<ng-container *ngIf="bannerConfig$ | async as config">
  <div
    *ngIf="config.enabled"
    class="maintenance-banner"
    [ngClass]="{
      'banner-info': config.type !== 'warning',
      'banner-warning': config.type === 'warning'
    }"
    role="status"
    aria-label="Maintenance notification"
  >
    <mat-icon class="banner-icon" *ngIf="config.type !== 'warning'" aria-hidden="true">info_outline</mat-icon>
    <mat-icon class="banner-icon" *ngIf="config.type === 'warning'" aria-hidden="true">warning_amber</mat-icon>
    <span class="banner-message">{{ config.message }}</span>
  </div>
</ng-container>
